(function(){
    'use strict';

    var bigSliderHeight = $('.big-slider').height();

    if (device.desktop() && window.location.pathname == '/') {
        $(window).on("scroll", function() {
            if ($(window).scrollTop() > bigSliderHeight)
                $('.header_nav').addClass('header_nav--active');
        });
    }

    $('.action_popup').on('click', function(event){
        event.preventDefault();

        var windowUrl = $(this).attr('href');
        $.colorbox({inline:true, href:windowUrl});
    });
    

})();